'use client'

import type { Post } from 'content-collections'

import Link from '@/components/link'

const Footer = (props: { post: Post }) => {
  const { post } = props

  return (
    <div className='mt-12 flex flex-col gap-6'>
      <div className='flex flex-wrap items-center justify-between gap-4 rounded-lg border p-4'>
        <div className='text-sm text-muted-foreground'>
          <span>Thanks for reading.</span>
        </div>
        <div className='flex items-center gap-4'>
          <Link href={`/blog`}>← Back to blog</Link>
        </div>
      </div>
    </div>
  )
}

export default Footer
